import { AbgSxProps } from '@abg/typings/styling';

export const dialogWrapper: AbgSxProps = {
  zIndex: 1400,
  '& .MuiDialog-paper': {
    position: {
      xs: 'fixed',
      sm: 'static',
    },
    bottom: {
      xs: 0,
      sm: 'auto',
    },
    margin: 0,
    width: { xs: '100%' },
    height: 'auto',
    maxWidth: { sm: '656px' },
    minHeight: { sm: '257px' },
  },
};

export const content: AbgSxProps = {
  marginTop: '0',
  padding: { xs: '16px', sm: '24px' },
};

export const title: AbgSxProps = {
  padding: { xs: '16px', sm: '24px' },
};

export const button: AbgSxProps = {
  width: { xs: '100%', sm: 'auto' },
  height: { xs: '48px', sm: '40px' },
};

export const buttonContainer: AbgSxProps = {
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  gap: '16px',
  justifyContent: { xs: 'center', sm: 'flex-end' },
  padding: {
    xs: '16px',
    sm: '16px 24px',
  },
  '& > *:not(style) ~ *:not(style)': {
    marginLeft: 0,
  },
};
